import { createReducer, on } from '@ngrx/store';

import { LineSwitcherActions } from './actions';
import { defaultLineSwitcherState } from './state';

export const lineSwitcherReducer = createReducer(
    defaultLineSwitcherState,
    on(LineSwitcherActions.initLineSwitcher, (state, action) => {
        return defaultLineSwitcherState;
    }),
    on(LineSwitcherActions.removePickHighlight, (state, action) => {
        return {
            ...state,
            swapPickState: {
                ...state.swapPickState,
                newPickId: null,
            },
        };
    }),
    on(LineSwitcherActions.openSportsLineSwitcher, (state, action) => {
        const pick = action.pick;

        return {
            ...state,
            swapPickState: {
                oldPickId: pick.id,
            },
        };
    }),
    on(LineSwitcherActions.updateOptionGroup, (state, action) => {
        return {
            ...state,
            optionGroup: action.payload,
        };
    }),
    on(LineSwitcherActions.updatePossibleWinningsState, (state, action) => {
        const winnings = action.payload;

        return {
            ...state,
            possibleWinningsState: {
                winnings: winnings.winnings,
                boostedWinnings: winnings.boostedWinnings,
                title: winnings.title,
            },
        };
    }),
    on(LineSwitcherActions.updateSwapButtonState, (state, action) => {
        return {
            ...state,
            swapButtonState: {
                ...state.swapButtonState,
                ...action.payload,
            },
        };
    }),
    on(LineSwitcherActions.addToSwapSelection, (state, action) => {
        const newPickId = state.swapPickState.oldPickId.isEqual(action.pickId) ? null : action.pickId;

        return {
            ...state,
            swapButtonState: {
                ...state.swapButtonState,
                isDisabled: !newPickId,
            },
            swapPickState: {
                ...state.swapPickState,
                newPickId,
            },
        };
    }),
    on(LineSwitcherActions.updateErrorState, (state, action) => {
        return {
            ...state,
            errorState: action.payload,
        };
    }),
    on(LineSwitcherActions.closeLineSwitcher, (state, action) => {
        return {
            ...defaultLineSwitcherState,
            swapPickState: {
                ...state.swapPickState,
                newPickId: state.swapPickState.newPickId,
            },
        };
    }),
    on(LineSwitcherActions.cancelLineSwitcher, () => {
        return defaultLineSwitcherState;
    }),
);
